<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <div class="search_box">
        <div class="feedback_get_type">
          <el-form class="searchForm">
            <el-form-item label="類型:" class="searchItem">
              <el-select v-model="type" placeholder="全部">
                <el-option label="選擇題" value="0"></el-option>
                <el-option label="多選題" value="1"></el-option>
                <el-option label="判斷題" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-form class="searchForm">
            <el-form-item label="地區:" class="searchItem">
              <el-select v-model="area" placeholder="全部">
                <el-option label="大陸港澳臺" value="0"></el-option>
                <el-option label="其他" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>

        <div style="display:flex;">
          <div class="btn" @click="addQuestion()">新增題目</div>
          <div
            class="btn"
            style="margin-left: 20px;margin-right: 20px;"
            @click="UploadQuestion()"
          >
            上傳題庫
          </div>
          <div class="btn" @click="search()">查詢</div>
          <div class="btn borderBtn" @click="reset()">重置</div>
        </div>
      </div>

      <div class="tableWrap">
        <el-table
          height="660px"
          stripe
          :data="feedbackList"
          style="width:100%;"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暫無題目"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in feedbackTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
                -
              </div>
              <div v-else-if="item.prop == 'type'">
                {{
                  scope.row[item.prop] == 1
                    ? "多選題"
                    : scope.row[item.prop] == 2
                    ? "判斷題"
                    : "單選題"
                }}
              </div>
              <div v-else-if="item.prop == 'area'">
                {{ scope.row[item.prop] == 1 ? "其他" : "大陸港澳臺" }}
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)"
                >編輯</el-button
              >
              <el-button type="text" @click="deleteQuestion(scope.row.id)"
                >刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <div class="feedback_detail" v-if="showFeedbackDetail">
      <div class="feedback_detail_bg"></div>
      <div class="feedback_detail_box">
        <div class="feedback_detail_title">
          {{ modalTitle == "add" ? "新增題目" : "編輯題目" }}
        </div>
        <div class="feedback_detail_list">
          <div class="list_name">標題：</div>
          <el-input
            placeholder="請輸入題目標題"
            v-model="question.questionName"
            style="width: 300px;"
            maxlength="250"
          />
          <!-- <el-input
            placeholder="请输入會員帳號"
            v-model="listMenuForm.title"
            style="width: 300px;"
          ></el-input> -->
        </div>
        <div class="feedback_detail_list">
          <div class="list_name">類型：</div>
          <el-select
            v-model="question.type"
            placeholder="请选择類型"
            @change="selectAreaChange"
          >
            <el-option
              v-for="item in questionType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="feedback_detail_list">
          <div class="list_name">地區：</div>
          <el-select
            v-model="question.area"
            placeholder="请选择地區"
            @change="selectArea"
          >
            <el-option
              v-for="item in areaType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="feedback_detail_list" v-if="question.type !== ''">
          <div class="list_name">答案：</div>
          <el-select
            v-if="question.type == '1'"
            multiple
            :key="'single'"
            v-model="Answer"
            placeholder="選擇答案"
          >
            <el-option
              v-for="(item, index) in resultType"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-else-if="question.type == '2' && question.area == 1"
            v-model="question.correctAnswer"
            :key="'multi'"
            placeholder="選擇答案"
          >
            <el-option key="A" label="yes" value="yes"> </el-option>
            <el-option key="B" label="no" value="no"> </el-option>
          </el-select>
          <el-select
            v-else-if="question.type == '2' && question.area == 0"
            v-model="question.correctAnswer"
            :key="'multis'"
            placeholder="選擇答案"
          >
            <el-option key="A" label="正确" value="正确"> </el-option>
            <el-option key="B" label="错误" value="错误"> </el-option>
          </el-select>
          <el-select
            v-else
            v-model="question.correctAnswer"
            placeholder="選擇答案"
            :key="'panduan'"
          >
            <el-option
              v-for="item in resultType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div
          class="feedback_detail_list"
          style="align-items: flex-start;"
          v-if="question.type == '1' || question.type == '0'"
        >
          <div class="list_name">問題選項：</div>
          <div style="width: 300px;">
            <div
              class="list_item"
              v-for="(item, index) in questionItemList"
              :key="index"
            >
              <div style="width: 60px;text-align: left;">
                選項{{ item.answerKey }}：
              </div>
              <el-input
                placeholder="請輸入問題選項"
                v-model="item.answerValue"
                style="width: 300px;"
                maxlength="100"
              />
            </div>
          </div>
        </div>
        <div class="btn_list">
          <div class="btn borderBtn" @click="closeDetail">取消</div>
          <div class="btn" @click="saveFn">保存</div>
        </div>
        <div class="close_btn">
          <button
            type="button"
            aria-label="Close"
            class="el-message-box__headerbtn"
            @click="closeDetail"
          >
            <i
              class="el-message-box__close el-icon-close"
              style="font-size: 0.2rem"
            ></i>
          </button>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="fanMoadl"
      title="上傳題庫"
      center
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div>
        <div style="display: flex;align-items: center;">
          <div class="list_name">地區：</div>
          <el-radio-group v-model="areaValue">
            <el-radio :label="0">大陸港澳臺</el-radio>
            <el-radio :label="1">其他</el-radio>
          </el-radio-group>
        </div>
        <div style="text-align: center;margin-top: 50px;">
          <el-upload
            class="downloadTableBtn colorfade"
            name="multipartFile"
            ref="excelUpload"
            :data="{
              area: this.areaValue
            }"
            :action="this.$GLOBAL.queationExcelUrl"
            :headers="{ Authorization: this.$cookie.get('auth') }"
            :with-credentials="true"
            :before-upload="beforeExcelUpload"
            :on-remove="handleRemove"
            :on-success="successExcel"
            :on-error="errorExcel"
            :accept="'.xlsx,.xls'"
            :show-file-list="false"
            :multiple="false"
            :file-list="fileList"
            :on-change="fileChange"
            :on-progress="onpress"
            :limit="1"
          >
            <span class="uploadSpan">上传文件</span>
          </el-upload>
        </div>
      </div>
    </el-dialog>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import Mint from "mint-ui"; //引入mint-ui
export default {
  data() {
    return {
      navBlock: "會員",
      navtitle: "入會答題",
      feedbackList: [],
      fanMoadl: false,
      areaValue: 0,
      fileList: [],
      feedbackTable: [
        {
          prop: "questionName",
          label: "標題",
          width: ""
        },
        {
          prop: "type",
          label: "類型",
          width: ""
        },
        {
          prop: "area",
          label: "地區",
          width: ""
        },
        {
          prop: "correctAnswer",
          label: "正確答案",
          width: "250"
        }
      ],
      currentPage: 1, // 分页
      total: 0,
      dialogVisible: false,
      lookDetail: {},
      listMenuForm: {
        title: "",
        selectArea: "",
        remarks: ""
      },
      showFeedbackDetail: false,
      detailIndex: 0,
      remarks: "",
      modalTitle: "add",
      type: "",
      area: "",
      questionType: [
        { value: 0, label: "單選題" },
        { value: 1, label: "多選題" },
        { value: 2, label: "判斷題" }
      ],
      areaType: [
        { value: 0, label: "大陸港澳臺" },
        { value: 1, label: "其他" }
      ],
      resultType: [
        // { value: "T", label: "選擇答案" },
        { value: "A", label: "A" },
        { value: "B", label: "B" },
        { value: "C", label: "C" },
        { value: "D", label: "D" }
      ],
      question: {
        type: "",
        questionName: "",
        area: "",
        correctAnswer: ""
      },
      questionItemList: [],
      Answer: []
    };
  },
  created() {
    this.getfeedbackList();
  },
  activated() {
    if (this.currentPage === 1) {
      this.getfeedbackList();
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取意见反馈列表信息
    getfeedbackList() {
      let _this = this;
      let url = `/request/question/list?page=${_this.currentPage}&size=10&type=${_this.type}&area=${_this.area}`;
      this.$get(url, {}, this.$GLOBAL.jsonConfig).then(res => {
        if (res.code === "00000") {
          _this.feedbackList = res.data.list;
          _this.total = res.data.total;
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getfeedbackList();
    },
    //上传
    beforeExcelUpload(file) {
      let _this = this;
      let result = _this.$checkData(file.name);
      if (file === "" || result === false) {
        _this.dialogVisible = true;
        _this.$propMessage("請選擇需要導入的Excel文件！", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
    },
    fileChange(file, fileList) {
      this.fileList = fileList;
    },
    onpress() {
      Mint.Indicator.open({
        text: "請稍候",
        spinnerType: "snake"
      });
    },

    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    // excel上传成功
    successExcel(res, file, fileList) {
      let _this = this;
      _this.dialogVisible = true;
      Mint.Indicator.close();
      _this.fanMoadl = false;
      if (res.code === "00000") {
        _this.$propMessage("上傳成功", "success", function() {
          _this.dialogVisible = false;
          _this.getfeedbackList();
        });
        _this.$refs.excelUpload.clearFiles();
      } else {
        _this.$propMessage(res.message, "error", function() {
          _this.dialogVisible = false;
        });
        _this.$refs.excelUpload.clearFiles();
      }
    },
    // excel上传失败
    errorExcel(err, file, fileList) {
      Mint.Indicator.close();
      let _this = this;
      _this.fanMoadl = false;
      _this.$refs.excelUpload.clearFiles();
      _this.dialogVisible = true;
      _this.$propMessage(err.message + ",請重新上傳", "error", function() {
        _this.dialogVisible = false;
      });
    },
    edit(id) {
      let url = `/request/question/detail/${id}`;
      this.$get(url, {}, this.$GLOBAL.jsonConfig).then(res => {
        if (res.code === "00000") {
          console.log(res.data);
          this.modalTitle = "edit";
          this.question = res.data.question;
          if (res.data.question.type == 1) {
            this.Answer = res.data.question.correctAnswer.split("、");
          }
          this.questionItemList = res.data.questionItemList;
          this.showFeedbackDetail = true;
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },
    lookBigImg(index) {
      let className = ".feedback_picture" + index;
      const frontViewer = this.$el.querySelector(className).$viewer;
      frontViewer.show();
    },
    UploadQuestion() {
      this.areaValue = 0;
      this.fanMoadl = true;
    },
    saveFn() {
      let _this = this;
      _this.dialogVisible = true;
      if (!_this.question.questionName) {
        _this.$propMessage("請輸入題目標題", "error", function() {
          _this.dialogVisible = false;
        });
        return;
      }
      if (_this.question.type === "") {
        _this.$propMessage("請選擇類型", "error", function() {
          _this.dialogVisible = false;
        });
        return;
      }
      if (_this.question.area === "") {
        _this.$propMessage("請選擇地區", "error", function() {
          _this.dialogVisible = false;
        });
        return;
      }
      if (this.question.type == 1) {
        if (_this.Answer.length === 0) {
          _this.$propMessage("請選擇答案", "error", function() {
            _this.dialogVisible = false;
          });
          return;
        } else if (_this.Answer.length == 1) {
          _this.$propMessage("至少選擇二個答案", "error", function() {
            _this.dialogVisible = false;
          });
          return;
        }
      } else {
        if (!_this.question.correctAnswer) {
          _this.$propMessage("請選擇答案", "error", function() {
            _this.dialogVisible = false;
          });
          return;
        }
      }
      if (this.question.type == 1 || this.question.type == 0) {
        const hasEmpty = _this.questionItemList.some(
          item => item.answerValue === "" || item.answerValue == null
        );
        if (hasEmpty) {
          _this.$propMessage("請輸入問題選項", "error", function() {
            _this.dialogVisible = false;
          });
          return;
        }
      }
      if (_this.question.type == 1) {
        _this.question.correctAnswer = this.Answer.join("、");
      }
      let param = {
        question: this.question,
        questionItemList: this.questionItemList
      };
      if (_this.modalTitle === "edit") {
        this.$put("/request/question", param, this.$GLOBAL.jsonConfig).then(
          res => {
            if (res.code === "00000") {
              _this.getfeedbackList();
              _this.dialogVisible = false;
              _this.showFeedbackDetail = false;
              _this.$successMessage("编辑成功");
            }
          }
        );
      } else {
        this.$post("/request/question", param, this.$GLOBAL.jsonConfig).then(
          res => {
            if (res.code === "00000") {
              _this.getfeedbackList();
              _this.dialogVisible = false;
              _this.showFeedbackDetail = false;
              _this.$successMessage("新增成功");
            }
          }
        );
      }
    },
    deleteQuestion(id) {
      let _this = this;
      _this
        .$confirm("是否刪除該題目?", "提示", {
          confirmButtonText: "刪除",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          //確認退出登錄
          _this.dialogVisible = true;
          this.$post(
            `/request/question/delete/${id}`,
            {},
            this.$GLOBAL.jsonConfig
          ).then(res => {
            if (res.code === "00000") {
              if (_this.feedbackList.length == 1 && _this.currentPage > 1) {
                _this.currentPage--;
              }
              _this.getfeedbackList();
              _this.dialogVisible = false;
              _this.showFeedbackDetail = false;
              _this.$successMessage("删除成功");
            } else {
              _this.dialogVisible = false;
            }
          });
        })
        .catch(() => {
          _this.dialogVisible = false;
        });
    },
    closeDetail() {
      this.showFeedbackDetail = false;
    },
    search() {
      this.currentPage = 1;
      this.getfeedbackList();
    },
    addQuestion() {
      let _this = this;
      _this.question.type = "";
      _this.question.questionName = "";
      _this.question.area = "";
      _this.modalTitle = "add";
      _this.showFeedbackDetail = true;
    },
    reset() {
      let _this = this;
      _this.type = "";
      _this.area = "";
      _this.currentPage = 1;
      _this.getfeedbackList();
    },
    selectAreaChange() {
      let _this = this;
      _this.Answer = [];
      _this.question.correctAnswer = "";
      _this.question.area = "";
      if (_this.question.type == 2) {
        if (_this.question.area == 1) {
          _this.questionItemList = [
            { answerKey: "A", answerValue: "yes" },
            { answerKey: "B", answerValue: "no" }
          ];
        } else {
          _this.questionItemList = [
            { answerKey: "A", answerValue: "正确" },
            { answerKey: "B", answerValue: "错误" }
          ];
        }
      } else {
        _this.questionItemList = [
          { answerKey: "A", answerValue: "" },
          { answerKey: "B", answerValue: "" },
          { answerKey: "C", answerValue: "" },
          { answerKey: "D", answerValue: "" }
        ];
      }
    },
    selectArea() {
      let _this = this;
      _this.Answer = [];
      _this.question.correctAnswer = "";
      if (_this.question.type == 2) {
        if (_this.question.area == 1) {
          _this.questionItemList = [
            { answerKey: "A", answerValue: "yes" },
            { answerKey: "B", answerValue: "no" }
          ];
        } else {
          _this.questionItemList = [
            { answerKey: "A", answerValue: "正确" },
            { answerKey: "B", answerValue: "错误" }
          ];
        }
      } 
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>
<style scoped lang="less">
.feedback_detail {
  position: fixed;
  z-index: 1000;
  .feedback_detail_bg {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #000;
    opacity: 0.5;
  }
  .feedback_detail_box {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 6.6rem;
    max-height: 5.6rem;
    padding-bottom: 30px;
    background-color: #fff;
    border-radius: 6px;
    color: #606266;
    overflow-y: auto;
    .feedback_detail_title {
      margin-bottom: 20px;
      padding: 15px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 16%);
      font-size: 16px;
      color: #303133;
      line-height: 1;
      font-weight: bold;
    }
    .feedback_detail_list {
      padding: 15px 40px;
      display: flex;
      align-items: center;
      .list_name {
        margin-right: 40px;
        width: 80px;
        flex-shrink: 0;
        text-align: right;
      }
      .list_content {
        text-align: left;
        word-break: break-all;
      }
      .feedback_picture {
        position: relative;
        margin-bottom: 48px;
        width: 286px;
        height: 178px;
        div {
          position: absolute;
          top: 100%;
          left: 0;
          margin-top: 13px;
          color: #6841dc;
          cursor: pointer;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      textarea {
        width: 298px;
        height: 52px;
        padding: 14px 18px;
        border-radius: 6px;
        background-color: #e8e6f0;
        border: none;
        resize: none;
      }
    }
    .btn_list {
      display: flex;
      align-items: center;
      justify-content: center;
      .borderBtn {
        margin-right: 50px;
      }
    }
    .cancel_btn {
    }
    .save_btn {
      margin: auto;
      width: 80px;
      height: 25px;
      line-height: 25px;
      border: 1px solid #ddd;
      text-align: center;
      border-radius: 5px;
      cursor: pointer;
    }
    .close_btn {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
    }
  }
}
.feedback_get_type {
  text-align: left;
  display: flex;
}
.search_box {
  display: flex;
  justify-content: space-between;
  .btn {
    margin-top: 40px;
  }
  .borderBtn {
    margin-left: 20px;
  }
}
.list_item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.downloadTableBtn {
  cursor: pointer;

  span {
    color: #fff;
    font-size: 0.12rem;
  }
}
/deep/.el-textarea__inner {
  line-height: 20px;
  height: 100%;
}
/deep/ .el-upload {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/questionList.vue